module.exports = __webpack_public_path__ + "img/2048.5653ff83.svg";